/**
 * The detail of a shown item a reply asked to open (`assistant_message.detail`: a train's itinerary…),
 * drawn on the item's own card. One at a time:
 *  - a reply that names one opens it, any other reply closes it (the conversation moved on);
 *  - a new screen closes it (ui-state `onScreen`);
 *  - the user closes it (a second touch, the close button), or it closes by itself `detailSeconds`
 *    (Settings → Screens) after it opened or was last touched; 0 keeps it open.
 * Opening goes through the backend (a touch and the voice are the same action, and the reply says it);
 * closing is the screen's own business.
 */
import type { AssistantMessage } from './wire';

export interface OpenDetail {
  /** The item it belongs to, as the backend names it (a train's id). */
  item: string;
  /** Which detail of it (`itinerary`): the domain draws each. */
  view: string;
  turnId: string;
  /** When it opened or was last touched (ms). */
  since: number;
}

/** What a reply leaves open: its own detail, or none. */
export function detailAfterReply(message: AssistantMessage, now: number): OpenDetail | null {
  const d = message.detail;
  return d ? { item: d.item, view: d.view, turnId: message.turn_id, since: now } : null;
}

/** When it closes by itself (ms), or null to stay open (`seconds` 0). */
export function detailClosesAt(detail: OpenDetail, seconds: number): number | null {
  return seconds > 0 ? detail.since + seconds * 1000 : null;
}
